var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('q-btn',{class:_setup.buttonClass,attrs:{"flat":"","no-caps":"","label":_vm.label,"disable":_vm.disable},on:{"click":function($event){return _vm.$emit('click', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }